import {
  contactEmail,
  contactNumber,
  IMAGE_URL,
  SITE_DESCRIPTION,
} from "../utils/constants";
import TAGS from "../public/headJson.json";

export const indexWebpageSchema = {
  "@context": "http://schema.org",
  "@type": "WebPage",
  url: "https://seekho.in/",
  headline:
    "Seekho: Short Learning Videos on Tech, Money, Personal Growth, & More",
  description: SITE_DESCRIPTION,
  name: "Seekho: Short Learning Videos on Tech, Money, Personal Growth, & More",
  inLanguage: "en",
};

export const organizationStructureData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Seekho",
  legalName: "Keyaro Edutech Pvt Ltd",
  url: "https://seekho.in/",
  logo: "https://images.seekhoapp.com/static/website/seekho-logo-website-v1.png",
  image: `${IMAGE_URL}/seekho.png`,
  description: TAGS.landingPage.description,
  foundingDate: "2020",
  founders: [
    { "@type": "Person", name: "Rohit Choudhary" },
    { "@type": "Person", name: "Yash Banwani" },
    { "@type": "Person", name: "Keertay Agarwal" },
  ],
  email: contactEmail,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: contactNumber,
    contactType: "customer service",
    availableLanguage: ["English", "Hindi"],
  },
  // address: {
  //   "@type": "PostalAddress",
  //   streetAddress: "Bellandur, Bengaluru",
  //   addressLocality: "Bengaluru",
  //   addressCountry: "IN",
  //   addressRegion: "KA",
  //   postalCode: "560130",
  // },
  sameAs: [
    "https://www.facebook.com/Seekho-App-100124665182099/",
    "https://www.linkedin.com/company/seekhoapp/",
    "https://www.instagram.com/seekhoapp/",
    "https://www.youtube.com/channel/UCs5t6HkoGqFcOSSVyL5W0mA",
    "https://www.youtube.com/channel/UCRvGwuCEGc68podaDhA9MXA",
  ],
};

export const indexWebsiteSchema = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  name: "Seekho",
  alternateName: ["Seekho", "Seekho App"],
  url: "https://seekho.in/",
  // image:
  //   "https://images.seekhoapp.com/static/website/seekho-logo-website-v1.png",
  // sameAs: [
  //   "https://www.facebook.com/Seekho-App-100124665182099/",
  //   "https://www.linkedin.com/company/seekhoapp/",
  //   "https://www.instagram.com/seekhoapp/",
  //   "https://www.youtube.com/channel/UCs5t6HkoGqFcOSSVyL5W0mA",
  //   "https://www.youtube.com/channel/UCRvGwuCEGc68podaDhA9MXA",
  // ],
};
